<script setup lang="ts">
import { isDesktop } from '@/helpers/detectDevice'

// NOTE: カスタムコンポーネントではv-showが使えないようなのでv-if使うか<div>で囲む
interface Props {
  showOverlay?: boolean
}
withDefaults(defineProps<Props>(), { showOverlay: true })

defineEmits<{
  (e: 'blur'): void
}>()
</script>
<template>
  <div
    v-if="showOverlay"
    class="modal-background bg-modal fill-vw-vh overlay"
  />
  <div
    v-if="isDesktop()"
    class="modal-container lo-center-h overlay scroll-auto"
    @mousedown.self="$emit('blur')"
  >
    <slot />
  </div>
  <div
    v-else
    class="modal-container lo-center overlay"
    @click.self="$emit('blur')"
  >
    <slot />
  </div>
</template>

<style scoped>
.modal-background,
.modal-container {
  z-index: var(--z-index-100);
}
</style>
